import { Controller } from 'react-hook-form';
import clsx from 'clsx';
import SegmentedControl from 'components/SegmentedControl/SegmentedControl';

import type { IMAIroQuestionSelectProps } from '../intefaces/IMAIroQuestionSelectProps';

import styles from '../scss/DetailsQuestion.module.scss';

function MAIROQuestionSelect({
  question,
  control,
  setValue,
  currentValue,
  questionIndex,
  disabled,
}: IMAIroQuestionSelectProps) {
  const options = question.options.map((option: { id: number, name: string }) => ({
    label: option.name,
    value: option.id,
  }));

  return (
    <div className={styles.questionWrapper}>
      <div className={styles.name}>
        <p>{question.name}</p>
      </div>
      <div className={styles.select}>
        <Controller
          control={control}
          name={`questions.${questionIndex}.answer.selectedOptionId`}
          key={`question-${question.id}-${questionIndex}`}
          render={({ field: { onChange, value } }) => {
            const effectiveValue = value !== undefined ? value : currentValue;

            return (
              <SegmentedControl
                options={options}
                className={clsx(styles.segments, {
                  [styles.disabledSegments]: disabled,
                })}
                classNameItem={styles.segmentItem}
                classNameActiveItem={styles.activeItem}
                value={effectiveValue ?? options[0]?.value}
                onChange={(newSelectedId: number | string) => {
                  onChange(newSelectedId);
                  // @ts-ignore
                  setValue(`questions.${questionIndex}.answer.selectedOptionId`, newSelectedId);
                }}
                disabled={disabled}
                fullWidth
              />
            );
          }}
        />
      </div>
    </div>
  );
}

export default MAIROQuestionSelect;
